module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += 'require(\'amd-loader\');\nconst test = require(\'ava\');\nconst Constants = require(\'./Constants\');\n\n\n\ntest(\'cp of water\', t => {\n	t.is(Constants.CP_OF_WATER, 1.0);\n});';

}
return __p
}